import React from "react";
import { cloneDeep } from "lodash";
import {
  ResultComparison,
  DialysisDragDrop,
} from "@learningblocks/storybook-components";

import { Legend } from "@learningblocks/storybook-components/lib/GelComponents/DialysisDragDropQuestion/Legend";

import "./style.scss";

export function ResultsComparisonDialysis(props) {
  const mergeDialysisTable = (
    dialysisTableData,
    dialysisTablePredictionData
  ) => {
    const dialysisTablePrediction = dialysisTablePredictionData;
    const dialysisTable = cloneDeep(dialysisTableData);

    dialysisTablePrediction?.responses?.forEach((response) => {
      if (response.cellId !== 0) {
        const originalCell = dialysisTable[
          response.colId
        ].colItems[0].cellItems.splice(response.dialysisId, 1);
        dialysisTable[response.colId].colItems[
          response.cellId
        ].cellItems.splice(response.cellId, 0, originalCell[0]);
      }
      dialysisTable[response.colId].colItems[response.cellId].cellItems[
        response.dialysisId
      ].selected = response.selected;
      if (response.value) {
        dialysisTable[response.colId].colItems[response.cellId].cellItems[
          response.dialysisId
        ].value = response.value;
      }
    });

    return dialysisTable;
  };

  const updateLabel = (dialysisTableData) => {
    const labels = {
      "0.0 M": "A",
      "0.2 M": "B",
      "0.4 M": "C",
      "0.6 M": "D",
      "0.8 M": "E",
      "1.0 M": "F",
    };

    dialysisTableData.forEach((col) => {
      col.colItems.forEach((colItem) => {
        if (colItem.cellType === "LABEL_CELL") {
          if (Object.prototype.hasOwnProperty.call(labels, colItem.label)) {
            colItem.label = labels[colItem.label];
          }
        }
      });
    });

    return dialysisTableData;
  };

  const getxAxisLabel = () => {
    console.log(props);
    if (props.dialysisConcentration.concentration === 0)
      return props.xAxisLabel;
    else return props.xAxisLabel.replace("0.0 M", "1.0 M");
  };

  const getPredictedGel = () => {
    return (
      <DialysisDragDrop
        id={props.id}
        theme={props.dialysisTheme}
        style={props.getlStyle}
        dialysisRange={props.dialysisRange}
        dialysisTable={mergeDialysisTable(
          props.dialysisTable,
          props.dialysisTablePrediction
        )}
        responses={props.dialysisTablePrediction}
        xAxisLabel={getxAxisLabel()}
      />
    );
  };

  const getActualGel = () => {
    const result = mapValues();
    return (
      <DialysisDragDrop
        id={props.id}
        theme={props.dialysisTheme}
        style={props.getlStyle}
        dialysisRange={props.dialysisRange}
        dialysisTable={updateLabel(
          mergeDialysisTable(props.dialysisTable, {
            type: "ideal",
            responses: [
              {
                colId: 1,
                cellId: 1,
                dialysisId: 0,
                value: result[0],
              },
              {
                colId: 2,
                cellId: 1,
                dialysisId: 0,
                value: result[1],
              },
              {
                colId: 3,
                cellId: 1,
                dialysisId: 0,
                value: result[2],
              },
              {
                colId: 4,
                cellId: 1,
                dialysisId: 0,
                value: result[3],
              },
              {
                colId: 5,
                cellId: 1,
                dialysisId: 0,
                value: result[4],
              },
              {
                colId: 6,
                cellId: 1,
                dialysisId: 0,
                value: result[5],
              },
            ],
          })
        )}
        responses={props.dialysisTablePrediction}
        xAxisLabel={getxAxisLabel()}
      />
    );

    function mapValues() {
      // const value = props.actualResults.tubeWeightsPostDialysis[index] - props.actualResults.tubeWeightsPreDialysis[index];
      // const values = [-1, -0.8, -0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6, 0.8, 1];
      // let closestValue = values[0];
      // let minDifference = Math.abs(value - values[0]);
      // for (let i = 1; i < values.length; i++) {
      //     let difference = Math.abs(value - values[i]);
      //     if (difference < minDifference) {
      //         closestValue = values[i];
      //         minDifference = difference;
      //     }
      // }
      // return closestValue;

      const arr = props.actualResults.tubeWeightsPostDialysis.map(
        (value, index) =>
          value - props.actualResults.tubeWeightsPreDialysis[index]
      );

      const positiveMapping = [5, 4, 3, 2, 1, 0];
      const negativeMapping = [0, -1, -2, -3, -4, -5];

      const arePositive = arr.every((value) => value >= 0);

      const sortedWithIndices = arr
        .map((value, index) => ({ value, index }))
        .sort((a, b) => b.value - a.value);

      const targetMapping = arePositive ? positiveMapping : negativeMapping;

      const result = new Array(arr.length);

      sortedWithIndices.forEach((item, index) => {
        if (index < targetMapping.length) {
          result[item.index] = targetMapping[index];
        }
      });

      for (let i = 0; i < arr.length; i++) {
        if (arr[i] === 0) result[i] = 0;
        if (props.actualResults.tubeWeightsPostDialysis[i] === -1)
          result[i] = 0;
      }

      return result;
    }
  };

  const getIdealGel = () => {
    if (props.dialysisConcentration.concentration != 1) {
      return (
        <DialysisDragDrop
          id={props.id}
          theme={props.dialysisTheme}
          style={props.getlStyle}
          dialysisRange={props.dialysisRange}
          dialysisTable={updateLabel(
            mergeDialysisTable(props.dialysisTable, {
              type: "ideal",
              responses: [
                {
                  colId: 1,
                  cellId: 1,
                  dialysisId: 0,
                  value: -1,
                },
                {
                  colId: 2,
                  cellId: 1,
                  dialysisId: 0,
                  value: 0,
                },
                {
                  colId: 3,
                  cellId: 1,
                  dialysisId: 0,
                  value: -3,
                },
                {
                  colId: 4,
                  cellId: 1,
                  dialysisId: 0,
                  value: -2,
                },
                {
                  colId: 5,
                  cellId: 1,
                  dialysisId: 0,
                  value: -4,
                },
                {
                  colId: 6,
                  cellId: 1,
                  dialysisId: 0,
                  value: -5,
                },
              ],
            })
          )}
          responses={props.dialysisTablePrediction}
          xAxisLabel={getxAxisLabel()}
        />
      );
    } else {
      return (
        <DialysisDragDrop
          id={props.id}
          theme={props.dialysisTheme}
          style={props.getlStyle}
          dialysisRange={props.dialysisRange}
          dialysisTable={updateLabel(
            mergeDialysisTable(props.dialysisTable, {
              type: "ideal",
              responses: [
                {
                  colId: 1,
                  cellId: 1,
                  dialysisId: 0,
                  value: 4,
                },
                {
                  colId: 2,
                  cellId: 1,
                  dialysisId: 0,
                  value: 5,
                },
                {
                  colId: 3,
                  cellId: 1,
                  dialysisId: 0,
                  value: 2,
                },
                {
                  colId: 4,
                  cellId: 1,
                  dialysisId: 0,
                  value: 3,
                },
                {
                  colId: 5,
                  cellId: 1,
                  dialysisId: 0,
                  value: 1,
                },
                {
                  colId: 6,
                  cellId: 1,
                  dialysisId: 0,
                  value: 0,
                },
              ],
            })
          )}
          responses={props.dialysisTablePrediction}
          xAxisLabel={getxAxisLabel()}
        />
      );
    }
  };

  console.log();

  return (
    <>
      <ResultComparison
        predictedState={{
          type: "component",
          component: (
            <>
              <p>These are your initial predictions:</p>
              {getPredictedGel()}
            </>
          ),
        }}
        actualState={{
          type: "component",
          component: (
            <>
              <p>These are your actual results:</p>
              {getActualGel()}
            </>
          ),
        }}
        idealState={{
          type: "component",
          component: (
            <>
              <p>These are your ideal results:</p>
              {getIdealGel()}
            </>
          ),
        }}
      />
      <Legend />
    </>
  );
}
